module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-11.f14c01bc.svg";